import { Auth } from '@aws-amplify/auth'

class AuthService {
  async signOut() {
    localStorage.clear()
  }
}

export default new AuthService()
